import { InjectionToken } from "@angular/core";

export interface IGoogleAnalitycsAware {
  changed()
}

export const IGOOGLEANALITYCSAWARE_INJECTIONTOKEN = new InjectionToken('IGoogleAnalitycsAware');
